// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_swiss_body = /** @type {(inputs: {}) => string} */ () => {
	return `Most kybun shoes are manufactured in Sennwald, in the St. Gallen Rhine Valley, where cutting-edge technology meets traditional shoemaking craftsmanship. The technology is backed by independent research from ETH Zurich and carries the AGR seal — awarded by the Campaign for Healthier Backs to products that meet strict ergonomic standards.`
};

const el_tech_swiss_body = /** @type {(inputs: {}) => string} */ () => {
	return `Τα περισσότερα παπούτσια kybun κατασκευάζονται στο Sennwald, στην κοιλάδα του Ρήνου του St. Gallen, όπου η τεχνολογία αιχμής συναντά την παραδοσιακή υποδηματοποιία. Η τεχνολογία υποστηρίζεται από ανεξάρτητη έρευνα του ETH Zurich και φέρει τη σφραγίδα AGR — που απονέμεται από την Εκστρατεία για Υγιέστερη Πλάτη σε προϊόντα που πληρούν αυστηρά εργονομικά πρότυπα.`
};

const ru_tech_swiss_body = /** @type {(inputs: {}) => string} */ () => {
	return `Большинство моделей kybun производится в Sennwald, в долине Рейна региона Санкт-Галлен, где передовые технологии сочетаются с традиционным обувным мастерством. Технология подтверждена независимыми исследованиями ETH Zurich и отмечена знаком AGR — присуждаемым Кампанией за здоровую спину продуктам, отвечающим строгим эргономическим стандартам.`
};

const he_tech_swiss_body = /** @type {(inputs: {}) => string} */ () => {
	return `רוב נעלי kybun מיוצרות ב-Sennwald, בעמק הריין של St. Gallen, שם טכנולוגיה חדשנית פוגשת אומנות נעלנית מסורתית. הטכנולוגיה נתמכת במחקר עצמאי של ETH Zurich ונושאת את חותם AGR — הניתן על ידי הקמפיין לגב בריא יותר למוצרים העומדים בתקנים ארגונומיים מחמירים.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_swiss_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_swiss_body(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_swiss_body", locale)
	if (locale === "en") return en_tech_swiss_body(inputs)
	if (locale === "el") return el_tech_swiss_body(inputs)
	if (locale === "ru") return ru_tech_swiss_body(inputs)
	if (locale === "he") return he_tech_swiss_body(inputs)
	return "tech_swiss_body"
};